// extracted by mini-css-extract-plugin
module.exports = {"site-layout-background":"main-template_site-layout-background__3Hd21","main-template-body":"main-template_main-template-body__25a3I"};